module.exports = __webpack_public_path__ + "static/media/icon-cadeado.c6a85bae.svg";